import './App.css';
import Navigation from './App/navigation/Navigation';

function App() {
  return (
    <div className='Navigation'>
      <Navigation />
    </div>
  );
}

export default App;
